module.exports = __webpack_public_path__ + "static/media/TypeScript.c06d3c06.svg";